import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useTranslation } from 'src/i18n';
import CircuitDynamicTable from '../CommissioningCircuit/CircuitDynamicTable';

// The deficiency codes from the paper form's guide. One per isometric, so a select rather
// than the form's row of checkbox columns.
const DEFICIENCY_CODES = ['none', 'code1', 'code2', 'code3', 'code4', 'other'];

// Section 4 (Field Insulation Inspections).
export default function EhtInsulationAuditFieldInspections (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();

  const columns = useMemo(() => [
    { key: 'isometricNumber', label: t('ehtInsulationAudit.fieldInspections.isometricNumber'), width: '35%' },
    {
      key: 'deficiencyCode',
      label: t('ehtInsulationAudit.fieldInspections.deficiency'),
      width: '20%',
      options: DEFICIENCY_CODES.map(code => ({
        value: code,
        label: t(`ehtInsulationAudit.deficiency.${code}`),
      })),
    },
    { key: 'comment', label: t('ehtInsulationAudit.fieldInspections.comment') },
  ], [t]);

  return (
    <CircuitDynamicTable
      readOnly={readOnly}
      title={t('ehtInsulationAudit.fieldInspections.title')}
      typeLegend={t('ehtInsulationAudit.fieldInspections.legend')}
      columns={columns}
      data={data?.getIn(['fieldInspections', 'items'])}
      extrasKey={['fieldInspections', 'items']}
      onChange={onChange}
      numbered
      deletable
      minRows={1}
    />
  );
}

EhtInsulationAuditFieldInspections.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

EhtInsulationAuditFieldInspections.defaultProps = {
  readOnly: false,
};
